import estate from "./estate";
import addressRule from "./addressRule";
import house from "./house";
import person from "./person";
import personRole from "./personRole";
import personTag from "./personTag";
import userBind from "./userBind";
import feeItem from "./feeItem";
import feeStandard from "./feeStandard";
import feePrivilege from "./feePrivilege";
import feePayDiscount from "./feePayDiscount";
import feePaySetting from "./feePaySetting";
import billAutoSchedule from "./billAutoSchedule";
import feeBill from "./feeBill";
import billNotify from "./billNotify";
import invoice from "./invoice";
import financeMonthStat from "./financeMonthStat";
import repairPrice from "./repairPrice";
import repairTicket from "./repairTicket";
import buildingNotice from "./buildingNotice";
import coGovStat from "./coGovStat";
import pushTemplate from "./pushTemplate";
import wxSubscribeTpl from "./wxSubscribeTpl";
import pushJob from "./pushJob";
import payMerchant from "./payMerchant";

export default {
  estate,
  addressRule,
  house,
  person,
  personRole,
  personTag,
  userBind,
  feeItem,
  feeStandard,
  feePrivilege,
  feePayDiscount,
  feePaySetting,
  billAutoSchedule,
  feeBill,
  billNotify,
  invoice,
  financeMonthStat,
  repairPrice,
  repairTicket,
  buildingNotice,
  coGovStat,
  pushTemplate,
  wxSubscribeTpl,
  pushJob,
  payMerchant,
};
